export default "__VITE_ASSET__sxqmCML2__"